import axios from "../config/axios.v2";
import {
  FAQ_URL,
  faqByIdUrl,
  faqBySlugUrl,
  faqByPageTypeUrl,
  faqItemUrl,
  faqItemByIndexUrl
} from "./faq.url.service";

const unwrap = (res) => res.data?.data ?? res.data;
const unwrapList = (res) => ({
  data: res.data?.datas || res.data,
  pagination: res.data?.pagination ?? {}
});

const handleError = (err) => {
  console.log("faqService err::", err);
  throw err;
};

const FaqService = {
  getAll: (params) => axios.get(FAQ_URL, { params }).then(unwrapList).catch(handleError),
  getById: (id) => axios.get(faqByIdUrl(id)).then(unwrap).catch(handleError),
  getBySlug: (slug) => axios.get(faqBySlugUrl(slug)).then(unwrap).catch(handleError),
  getByPageType: (pageType) =>
    axios.get(faqByPageTypeUrl(pageType)).then(unwrap).catch(handleError),
  create: (payload) => axios.post(FAQ_URL, payload).then(unwrap).catch(handleError),
  update: (id, payload) => axios.patch(faqByIdUrl(id), payload).then(unwrap).catch(handleError),
  remove: (id) => axios.delete(faqByIdUrl(id)).then(unwrap).catch(handleError),
  addItem: (id, payload) => axios.post(faqItemUrl(id), payload).then(unwrap).catch(handleError),
  removeItem: (id, index) =>
    axios.delete(faqItemByIndexUrl(id, index)).then(unwrap).catch(handleError)
};

export default FaqService;
